export const ROLE = Object.freeze({
	API_DOC_VIEWER: "apiDocViewer",
	BATCH_ADMIN: "batchAdmin",
	BATCH_VIEWER: "batchViewer",
	BOT: "bot",
	BOT_ADMIN: "botAdmin",
	PARTNER: "partner",
	BROKER: "broker",
	CALCULATOR: "calculator",
	CODE_ADMIN: "codeAdmin",
	EMPLOYER_ADMIN: "employerAdmin",
	CONTENT_ADMIN: "contentAdmin",
	CONTENT_VIEWER: "contentViewer",
	DEVELOPER: "developer",
	HRA_EXPENSE_ADMIN: "hraExpenseAdmin",
	IN_RECOVERY: "inRecovery",
	IN_SIGNUP: "inSignup",
	LOG_VIEWER: "logViewer",
	OWN_KEY_ADMIN: "ownKeyAdmin",
	QA: "qa",
	ROLE_ADMIN: "roleAdmin",
	SCHEDULER: "scheduler",
	SET_PASSWORD: "setPassword",
	SYS_ADMIN: "sysAdmin",
	UNVERIFIED_EMAIL: "unverifiedEmail",
	UNVERIFIED_USER: "unverifiedUser",
	USER: "user",
	USER_ADMIN: "userAdmin",
	USER_VIEWER: "userViewer",
	WEX_INTEGRATOR: "wexIntegrator"
});

// Helper to produce a canonical, case-insensitive token (e.g. "sysAdmin" -> "SYSADMIN")
export const canonRole = (s) => String(s || "").replace(/[^a-z0-9]/gi, "").toUpperCase();

// Normalize roles from various backend shapes into canonical tokens
export function normalizeRoles(data = {}) {
  const out = new Set();
  const push = (r) => r && out.add(canonRole(r));

  if (Array.isArray(data.roles)) data.roles.forEach(push);
  if (data.role) push(data.role);

  // Flag fallbacks
  if (data.isSysAdmin) push(ROLE.SYS_ADMIN);
  if (data.isEmployerRootAdmin) push("SUPER_ADMIN");

  if (out.size === 0) {
    if (data.employerId) push("READ_ONLY");
    else push("CUSTOMER");
  }

  return Array.from(out);
}

export default ROLE;
